export const coreAddresses = {
  balanceTracker: "0x029fDEe85BEdB0553D6fdc538546586641DD7438",
  eVaultFactory: "0x7F321498A801A191a93C840750ed637149dDf8D0",
  eVaultImplementation: "0x30a9A9654804F1e5b3291a86E83EdeD7cF281618",
  eulerEarnFactory: "0x75F49a2621b6DeC6a5baB22ce961bF3e676EFAE6",
  evc: "0x5301c7dD20bD945D2013b48ed0DEE3A284ca8989",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x1D4b9e6ACACdc82Dd9E903C3F4431558Af32C4A9",
  sequenceRegistry: "0xfE9011FD097cd35866b9e4740BBC88B4ef26E3ba",
} as const
